import { booleanHeader, Box, Container, CreateHeaders, dateHeader, HeaderSizeEnum, Skeleton, textHeader } from '@frontend-workspace/react-shared-lib';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import PageTitle from '../page-title/page-title';
import { useGetRequestNewHook, useTableConfigHook } from '../requestUtils';
import WebkuaTable from '../webkua-table/webkua-table';
import styles from './users.module.scss';

/* eslint-disable-next-line */
export interface UsersProps { }

interface IAllAccounts {
  id: string;
  email: string;
  isActive: boolean;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  role: string;
  username: string;
  created: string;

}
export function Users(props: UsersProps) {
  const { t } = useTranslation();
  const tableConfig = useTableConfigHook("adminUsers");
  const { data: users, isLoading }: { data: IAllAccounts[], isLoading: boolean } = useGetRequestNewHook(`accounts/action/detailed`, []);
  const [onlyActive, setOnlyActive] = useState(true);

  const dateFilteredusers = users.filter(u => {
    if (onlyActive) {
      return u.isActive;
    }
    return true;
  });
  const handleOnlyActiveToggle = () => setOnlyActive(!onlyActive);
  const headers = CreateHeaders([
    textHeader("email", t("standard.email"), HeaderSizeEnum.MEDIUM),
    textHeader("firstName", t("standard.firstName"), HeaderSizeEnum.MEDIUM),
    textHeader("lastName", t("standard.lastName"), HeaderSizeEnum.MEDIUM),
    textHeader("companyNumber", t("standard.companyNumber"), HeaderSizeEnum.SMALL),
    textHeader("companyName", t("standard.companyName"), HeaderSizeEnum.MEDIUM),
    textHeader("phoneNumber", t("standard.phone"), HeaderSizeEnum.MEDIUM),
    textHeader("role", t("standard.role"), HeaderSizeEnum.MEDIUM),
    textHeader("licenseAccesses", t("standard.licenses"), HeaderSizeEnum.MEDIUM),
    textHeader("productNames", t("standard.products"), HeaderSizeEnum.MEDIUM),
    textHeader("responsibleForContracts", t("standard.contractResponsible"), HeaderSizeEnum.MEDIUM),
    textHeader("language", t("standard.language"), HeaderSizeEnum.SMALL),
    dateHeader("createdTime", t("standard.created")),
    booleanHeader("isActive", t("standard.active")),
    booleanHeader("isActivated", t("standard.activatedOnMyPage")),
  ]);
  return (
    <Container
      className="container-fluid pt-4 px-0"
      maxWidth={false}
      sx={{ paddingBottom: '50px' }}>
      <Row>
        <Col>
          <Box
            component="div"
            className="pb-5">
            <PageTitle title={t("standard.accounts")} subtitle={`(${t("standard.admin")})`} />
            {!dateFilteredusers ?
              <>
                <div className='d-flex justify-content-end'>
                  <Skeleton animation="wave" width={150} height={50} />
                </div>
                <Skeleton variant="rectangular" animation="wave" width='100%' height={1100} />
                <div className='d-flex justify-content-end'>
                  <Skeleton animation="wave" width={150} height={50} />
                </div></> :
              <WebkuaTable
                headers={headers}
                tableFilters={[
                  {
                    label: t("standard.activeOnly"),
                    checked: onlyActive,
                    onChange: handleOnlyActiveToggle
                  }
                ]}
                isLoading={isLoading}
                data={dateFilteredusers}
                tableConfig={tableConfig}
              />
            }
          </Box>
        </Col>
      </Row>
    </Container >
  );
}

export default Users;
